import { US_STATES, US_STATE_VALUES } from './us-states'

export interface RegionOption {
  value: string
  label: string
}

export type SupportedCountryCode = 'US' | 'CA'

export interface CountryOption {
  value: SupportedCountryCode
  label: string
}

export const DEFAULT_COUNTRY: SupportedCountryCode = 'US'

export const SUPPORTED_COUNTRIES: ReadonlyArray<CountryOption> = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' }
]

export const SUPPORTED_COUNTRY_VALUES: ReadonlyArray<string> = SUPPORTED_COUNTRIES.map(
  (c) => c.value
)

export const CA_PROVINCES: ReadonlyArray<RegionOption> = [
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  { value: 'MB', label: 'Manitoba' },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland and Labrador' },
  { value: 'NS', label: 'Nova Scotia' },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NU', label: 'Nunavut' },
  { value: 'ON', label: 'Ontario' },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  { value: 'SK', label: 'Saskatchewan' },
  { value: 'YT', label: 'Yukon' }
]

export const CA_PROVINCE_VALUES: ReadonlyArray<string> = CA_PROVINCES.map((p) => p.value)

export const getRegionsForCountry = (country: string | undefined): ReadonlyArray<RegionOption> => {
  if (country === 'CA') return CA_PROVINCES
  return US_STATES
}

export const getRegionValuesForCountry = (country: string | undefined): ReadonlyArray<string> => {
  if (country === 'CA') return CA_PROVINCE_VALUES
  return US_STATE_VALUES
}

export const getRegionLabelForCountry = (country: string | undefined): string =>
  country === 'CA' ? 'Province' : 'State'

export const findRegionByValue = (
  country: string | undefined,
  value: string | undefined
): RegionOption | undefined => {
  if (!value) return undefined
  const upper = value.toUpperCase()
  return getRegionsForCountry(country).find((r) => r.value === upper)
}
